export { default } from "./StrainReviews";
